import React from "react";
import { Box, Grid, Typography, Paper } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";

function AboutSection() {
  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)",
        py: 8,
        px: 2,
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "radial-gradient(circle at 30% 50%, rgba(59, 130, 246, 0.1) 0%, transparent 50%)",
          pointerEvents: "none",
        },
      }}
    >
      <Grid container justifyContent="center" sx={{ position: "relative", zIndex: 1 }}>
        <Grid item xs={12} md={8} lg={6}>
          <Box sx={{ mb: 5 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <Box
                sx={{
                  width: "50px",
                  height: "50px",
                  background: "linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%)",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                }}
              >
                <BusinessIcon sx={{ fontSize: "1.8rem" }} />
              </Box>
              <Typography
                variant="h4"
                fontWeight="700"
                sx={{
                  color: "white",
                  fontSize: { xs: "1.8rem", sm: "2rem" },
                }}
              >
                About Us
              </Typography>
            </Box>
            <Box
              sx={{
                width: "60px",
                height: "4px",
                background: "linear-gradient(90deg, #3b82f6 0%, #06b6d4 100%)",
                borderRadius: "2px",
              }}
            />
          </Box>

          <Paper
            elevation={0}
            sx={{
              background: "rgba(255, 255, 255, 0.05)",
              border: "1px solid rgba(59, 130, 246, 0.3)",
              borderRadius: "16px",
              p: 4,
              backdropFilter: "blur(10px)",
            }}
          >
            <Typography
              sx={{
                fontSize: "1.1rem",
                lineHeight: "1.8",
                color: "#e0e7ff",
                fontWeight: "400",
                letterSpacing: "0.5px",
              }}
            >
              "Power Electro Control India (PEC) is a trusted dealer in Bengaluru specializing in submersible motor pumps, electrical cables, control panels, and HDPE pipes. We are committed to providing premium quality products from India's leading manufacturers, delivering reliable solutions for agricultural, industrial, and residential applications."
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

export default AboutSection;
